<template id="dialogEditSiteTmpl">
    <!-- FORM EDIT SITE START -->
    <v-dialog v-model="dialogEditSiteIsOpen" v-if="site2edit != null" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-btn icon dark v-on:click="closeEditSite()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="site2edit.site_id != null">{{$t('lbl.site')}}: {{site2edit.site_name}}</v-toolbar-title>
                <v-toolbar-title v-else>{{$t('lbl.newSite')}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-form ref="editSiteFrm" v-model="validNewSiteFrm" lazy-validation>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field v-model="site2edit.site_name" :rules="siteNameRules" :label="$t('lbl.siteName')" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field v-model="site2edit.description" :rules="siteDescriptionRules" :label="$t('lbl.siteDescription')" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-select v-model="site2edit.site_category" :items="siteCategoryItems" :rules="siteCategoryRules" :label="$t('lbl.siteCategory')"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field type="number" v-model.number="site2edit.site_location.latitude" :label="$t('lbl.siteLatitude')" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field type="number" v-model.number="site2edit.site_location.longitude" :label="$t('lbl.siteLongitude')" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-switch v-model="site2edit.flags.active" :label="$t('lbl.active')"></v-switch>
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-btn class="button-main" v-on:click="editSite()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- FORM EDIT SITE END -->
</template>

<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    data: () => ({
        siteCategoryItems: [],
        dialogEditSiteIsOpen: false,
		validNewSiteFrm: false,
        siteNameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		siteDescriptionRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		siteCategoryRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
    }),
    props: ['site2edit'],
    mounted() 
    {
        //=== STARTUP
        this.loadSiteCategoryItems();
    },
    destroyed() 
    {

    },
    methods: {
        loadSiteCategoryItems()
		{
			this.siteCategoryItems = this.getSiteCategoryItems();
		}, 
        openEditSite() 
        {
            this.dialogEditSiteIsOpen = true;
        }, 
        closeEditSite()
		{
			this.dialogEditSiteIsOpen = false;
			// DA ERRORE
            //this.site2edit = null;
		},
        editSite() {
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				if (this.$refs.editSiteFrm.validate())
				{	
					var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites';
					if(!this.isEmptyObj(this.site2edit))
					{
						var obj2send = null;
						if(!this.isEmptyString(this.site2edit['site_id']) )
						{
							endpoint2go += '/' +this.site2edit['site_id'];
							
							//alert("CHIAMO PATCH PERCHE EDIT");
							obj2send = {
								'site_name': this.site2edit['site_name'],
								'description': this.site2edit['description'],
								'site_category': this.site2edit['site_category'],
								'site_location': this.site2edit['site_location'],
								'flags': this.site2edit['flags'],
							};
							console.log("PATCH");
							console.log(endpoint2go)
							console.log("OGGETTO CHE SPEDISCO");
							console.log(obj2send);
							console.log(JSON.stringify(obj2send))
							this.$root.genericPatchAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackEditSite, 'err.savingSite');
						} else {
							
							//alert("CHIAMO POST PERCHE CREATE");
							obj2send = this.site2edit;
							this.$root.genericPostAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackEditSite, 'err.savingSite');
						} 
					} 
				}
			}	
		},
		callbackEditSite(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{	
				console.log(responseData);

				this.dialogEditSiteIsOpen= false;
				
				// RE-LOAD ORGANIZATIONS
				events.$emit(constants.EVENT_DO_LOAD_SITE_LIST);

				this.$root.setDialogMsg(i18n.t('msg.saveok'));
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.savingSite"));
			}
		},
    }
}
</script>       